import { takeLatest, put, call } from 'redux-saga/effects';
import {
    setLoading,
    setSuccess,
    setGroupPermissionsList,
    setGroupPermissionsCreation,
    clearGroupPermissionsData,
    setPermissionsList,
    setLoadingPermissions
} from '@store/reducers/groupPermissionsReducer';
import {
    fetchingGroupPermissionsList,
    createGroupPermissions,
    getGroupPermissionsDetail,
    updateGroupPermissions,
    clearGroupPermissions,
    fetchPermissionsList
} from '@store/actions/groupPermissionsActions';
import { toast } from 'react-toastify';
import { history } from '@utils/BrowserHistory';
import { resourceService } from '@libs/axios';
import { ResponseType } from '@store/index';
// just draft
const API_URL = process.env.REACT_APP_API_URL;

function* fetchGroupPermissionsListData(action: ReturnType<typeof fetchingGroupPermissionsList>) {
    const { code_name, page = 1, page_size = 200 } = action.payload || {};
    yield put(setLoading(true));
    try {
        const response: ResponseType = yield call(
            resourceService.get,
            API_URL + '/api/group_permissions/', {
            params: {
                code_name,
                page,
                page_size
            }
        }
        );

        if (response?.data) {
            yield put(setGroupPermissionsList(response.data));
            yield put(setLoading(false));
        }
    } catch (e: any) {
        yield put(setLoading(false));
        let error: Error = e;
        console.log(error);
    }
}

function* createGroupPermissionsSaga(action: ReturnType<typeof createGroupPermissions>) {
    yield put(setSuccess(false));
    yield put(setLoading(true));
    try {
        const response: ResponseType = yield call(resourceService.post, API_URL + '/api/group_permissions/', {
            ...action.payload
        });
        if (response.status == 201) {
            yield put(setSuccess(true));
            toast.success('Tạo nhóm quyền mới thành công');
            yield put(setLoading(false));
            yield put(setGroupPermissionsCreation(response.data));
            history.push(`/admin/groupdetail/?mode=view&id=${response.data.id}`);
        } else {
            yield put(setSuccess(false));
            yield put(setLoading(false));
        }
    } catch (error: any) {
        const errorMessage = error?.response?.data?.detail || error?.message || 'An error occurred';
        console.log(errorMessage);
        toast.error(`Tạo nhóm quyền mới thất bại ${errorMessage}`);
        yield put(setSuccess(false));
        yield put(setLoading(false));
    }
}

function* getGroupPermissionsDetailSaga(action: any) {
    const { id } = action.payload;
    yield put(setLoading(true));
    try {
        const response: ResponseType = yield call(resourceService.get, API_URL + `/api/group_permissions/${id}/`);
        if (response?.data) {
            yield put(
                setGroupPermissionsCreation({
                    name: response.data?.name,
                    code: response.data?.code,
                    description: response.data?.description,
                    status: response.data?.status,
                    permissions: response.data?.permissions
                }),
            );
            yield put(setLoading(false));
        }
    } catch (error: any) {
        yield put(setLoading(false));
        console.log(error);
    }
}

function* clearGroupPermissionsSaga(action: any) {
    yield put(clearGroupPermissionsData());
}

function* updateGroupPermissionsSaga(action: any) {
    yield put(setSuccess(false));
    yield put(setLoading(true));
    try {
        const { data, id } = action.payload;
        const updatedData = {
            ...data,
        };

        const response: ResponseType = yield call(resourceService.put, API_URL + `/api/group_permissions/${id}/`, updatedData);
        if (response.status == 200) {
            toast.success('Chỉnh sửa thông tin nhóm quyền thành công');
            yield put(setSuccess(true));
            yield put(setLoading(false));
            yield put(
                setGroupPermissionsCreation({
                    name: response.data?.name,
                    code: response.data?.code,
                    description: response.data?.description,
                    status: response.data?.status,
                    permissions: response.data?.permissions
                }),
            );
            history.push(`/admin/groupdetail/?mode=view&id=${response.data.id}`);
        } else {
            yield put(setSuccess(false));
            yield put(setLoading(false));
        }
    } catch (error: any) {
        const errorMessage = error?.response?.data?.detail || error?.message || 'An error occurred';
        console.log(errorMessage);
        toast.error(`Chỉnh sửa thông tin nhóm quyền thất bại: ${errorMessage}`);
        yield put(setSuccess(false));
        yield put(setLoading(false));
    }
}

function* fetchPermissionsListSaga(action: any) {
    try {
        yield put(setLoadingPermissions(true));
        const { page = null, page_size = null } = action.payload || {};
        const response: ResponseType = yield call(
            resourceService.get,
            API_URL + `/api/permissions/`,
            {
                params: {
                    page,
                    page_size
                }
            }
        );
        if (response.status === 200) {
            yield put(setPermissionsList(response.data?.results));
            yield put(setLoadingPermissions(false));
        }
    } catch (error: any) {
        yield put(setLoadingPermissions(false));
        console.log(error);
    }
}

function* groupPermissionsSaga() {
    yield takeLatest(fetchingGroupPermissionsList, fetchGroupPermissionsListData),
        yield takeLatest(createGroupPermissions, createGroupPermissionsSaga),
        yield takeLatest(getGroupPermissionsDetail, getGroupPermissionsDetailSaga),
        yield takeLatest(clearGroupPermissions, clearGroupPermissionsSaga),
        yield takeLatest(fetchPermissionsList, fetchPermissionsListSaga),
        yield takeLatest(updateGroupPermissions as any, updateGroupPermissionsSaga)
}

export default groupPermissionsSaga;
